import styled from 'styled-components';

export default styled.img`
  max-width: 100%;
  max-height: 100%;
`;
